"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgLocation = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M11.077 1.481c-3.563.375-6.469 3.188-6.984 6.75-.282 2.156.234 4.125 1.359 5.719l5.719 8.203c.375.562 1.219.562 1.64 0l5.72-8.203c.89-1.313 1.452-2.86 1.452-4.547-.047-4.734-4.125-8.484-8.906-7.922zm.89 11.906a3.981 3.981 0 01-3.984-3.984 3.981 3.981 0 013.985-3.984 3.981 3.981 0 013.984 3.984 3.981 3.981 0 01-3.984 3.984z" })));
};
exports.default = SvgLocation;
//# sourceMappingURL=Location.js.map